import { render, staticRenderFns } from "./resourcesList.vue?vue&type=template&id=19ee8ae3&scoped=true"
import script from "./resourcesList.vue?vue&type=script&lang=js"
export * from "./resourcesList.vue?vue&type=script&lang=js"
import style0 from "./resourcesList.vue?vue&type=style&index=0&id=19ee8ae3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee8ae3",
  null
  
)

export default component.exports